export const errorCodes = {
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  UNAUTHORIZED: 401,
};
